import { render, staticRenderFns } from "./WalletImportRemark.vue?vue&type=template&id=a2397e92&scoped=true&"
import script from "./WalletImportRemark.vue?vue&type=script&lang=js&"
export * from "./WalletImportRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2397e92",
  null
  
)

export default component.exports